import { useState, useCallback, useEffect } from "react";

export const useCodeEditorColumnResizer = () => {
  const [isResizing, setIsResizing] = useState(false);
  const [horizontalWidth, setHorizontalWidth] = useState(0);
  const [resizeStartPoint, setResizeStartPoint] = useState(0);

  const startResizing = useCallback((mouseEvent) => {
    setIsResizing(true);
    setResizeStartPoint(parseInt(mouseEvent.clientX));
  }, []);

  const stopResizing = useCallback(() => {
    setIsResizing(false);
    setResizeStartPoint(0);
  }, []);

  const resize = useCallback(
    (mouseEvent) => {
      if (isResizing && resizeStartPoint !== 0) {
        setHorizontalWidth(horizontalWidth - -1 * (mouseEvent.clientX - resizeStartPoint));
      }
    },
    [isResizing]
  );

  useEffect(() => {
    window.addEventListener("mousemove", resize);
    window.addEventListener("mouseup", stopResizing);

    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [resize, stopResizing]);

  return {
    startResizing,
    horizontalWidth,
    setHorizontalWidth,
  };
};
